var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("404")]),_c('div',{staticClass:"btn-box"},[_c('button',{on:{"click":_vm.back}},[_vm._v("返回上一页")]),_c('button',{on:{"click":_vm.toLogin}},[_vm._v("去登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }